module.exports = __webpack_public_path__ + "images/cards/learn-how.svg";